export default "__VITE_ASSET__D2yFGyKP__"